import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Spinner from '../audi-ui-components/Spinner';

const Loader = (props) => {
  return (
    <div className={classnames("loader", props.type)}>
      <div className="loader__inner">
        <Spinner isContinuous />
        {props.children && <div>{props.children}</div>}
      </div>
    </div>
  );
}

Loader.propTypes = {
  type: PropTypes.oneOf(['overlay', 'placeholder'])
};

Loader.defaultProps = {
  type: 'overlay'
};

export default Loader;
